export const numberFieldsValidation = (value: string, min: number, max: number) => (+value >= min && +value <= max)
